import type { FunctionComponent, ReactNode } from 'react';

import { Button, ButtonVariant } from '../controls/button/Button';
import { IconButton, Icons } from '../controls/iconButton/IconButton';
import { L12nText } from '../text/L12nText';

import styles from './Toast.module.css';

export interface ToastProps {
  duration?: number;
  message: string;
  onClose: () => void;
  icon?: ReactNode;
  button?: {
    tk: string;
    onClick: () => void;
  };
  msgDynamicValues?: string[];
}

export const Toast: FunctionComponent<ToastProps> = ({
  message,
  duration = 6000,
  onClose,
  icon,
  button,
  msgDynamicValues,
}) => {
  return (
    <div className={styles.toast} data-testid="toast">
      <div className={styles.toast_container}>
        <div>{icon}</div>

        <div data-testid="toast-text" className={styles.toast_text}>
          <L12nText tk={message} dynamicValues={msgDynamicValues} />
        </div>

        <div>{button && <Button variant={ButtonVariant.MAIN} {...button} className={styles.toast_btn} />}</div>

        <div>
          <IconButton timer={duration} icon={Icons.Close} onClick={onClose} data-testid="toast-timer" />
        </div>
      </div>
    </div>
  );
};
